import { render, staticRenderFns } from "./becomingSupplierDistributorModal.vue?vue&type=template&id=6b034bc4&scoped=true"
import script from "./becomingSupplierDistributorModal.vue?vue&type=script&lang=js"
export * from "./becomingSupplierDistributorModal.vue?vue&type=script&lang=js"
import style0 from "./becomingSupplierDistributorModal.vue?vue&type=style&index=0&id=6b034bc4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b034bc4",
  null
  
)

export default component.exports